<script lang="ts">
	import { icon as faIcon } from "@fortawesome/fontawesome-svg-core";
	import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
	export let icon: IconDefinition;
	$: result = faIcon(icon);
</script>

{#if result}
	{@html result.html[0]}
{/if}
